var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 13,
    viewBox: "0 0 21 13",
    width: 21,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10.3239 4.23069c2.2091 0 4 1.79088 4 3.99998 0 2.20923-1.7909 4.00003-4 4.00003-2.2092 0-4.00006-1.7908-4.00006-4.00003 0-2.2091 1.79086-3.99998 4.00006-3.99998zm0 1.49998c-1.38073 0-2.50006 1.1193-2.50006 2.5s1.11933 2.50003 2.50006 2.50003c1.3807 0 2.5-1.11933 2.5-2.50003s-1.1193-2.5-2.5-2.5zm0-5.004596c4.6135 0 8.5961 3.150006 9.7011 7.564396.1006.4018-.1436.8091-.5454.9097-.4019.1005-.8091-.1436-.9097-.5455-.9389-3.75064-4.3247-6.4286-8.246-6.4286-3.92312 0-7.30996 2.68026-8.2472 6.4332-.10036.4018-.5075.6462-.90937.5459-.401868-.1004-.646288-.5075-.545928-.9094 1.103088-4.41698 5.086928-7.569696 9.702498-7.569696z",
    fill: "#7a8295"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOpen);
export default __webpack_public_path__ + "static/media/eye_open.6bede30170578d24343d0af8cfaa0679.svg";
export { ForwardRef as ReactComponent };